import { get } from 'svelte/store'

import {
  cancelSubscription as cancelSubscriptionRequest,
  createSubscription as createSubscriptionRequest,
  getSubscription as getSubscriptionRequest,
  getUserSubscriptions,
  normalizeSubscriptionsResponse,
} from '@packages/utils/lib/subscriptions'
import type { TCreateSubscriptionRequest, TSubscription, TSubscriptionListParams } from '@packages/utils/types'
import { configStore } from '@src/stores/config'

const getSubscriptionApiUrl = () => get(configStore).credenza.generalApiUrl

export const createSubscription = async (data: TCreateSubscriptionRequest): Promise<TSubscription> => {
  return createSubscriptionRequest(getSubscriptionApiUrl(), {
    ...data,
    chain_type: data.chain_type ?? 'sui',
  })
}

export const getSubscription = async (id: string): Promise<TSubscription> => {
  return getSubscriptionRequest(getSubscriptionApiUrl(), id)
}

export const listSubscriptions = async (params?: TSubscriptionListParams): Promise<TSubscription[]> => {
  const response = await getUserSubscriptions(getSubscriptionApiUrl(), params)

  return normalizeSubscriptionsResponse(response)
}

export const cancelSubscription = async (id: string): Promise<TSubscription> => {
  return cancelSubscriptionRequest(getSubscriptionApiUrl(), id)
}
